exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-test-tsx": () => import("./../../../src/pages/test.tsx" /* webpackChunkName: "component---src-pages-test-tsx" */),
  "component---src-prismic-templates-page-js": () => import("./../../../src/prismic/templates/page.js" /* webpackChunkName: "component---src-prismic-templates-page-js" */)
}

